import { render, staticRenderFns } from "./min-card.vue?vue&type=template&id=bc1a3450&scoped=true&"
import script from "./min-card.vue?vue&type=script&lang=ts&"
export * from "./min-card.vue?vue&type=script&lang=ts&"
import style0 from "./min-card.vue?vue&type=style&index=0&id=bc1a3450&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1a3450",
  null
  
)

export default component.exports